import { StandardPageSize } from "@react-pdf/types";
import { Orientation } from "@react-pdf/types/page";

export type FormPrintOptionsType = {
  size: StandardPageSize;
  orientation: Orientation;
  printColor: FormPrintColorEnum;
  paperColor: FormPaperColorEnum;
};

export type BaseFormLabelType = {
  id: number;
  ean: string;
  name: string;
  discount: string;
  discountDetail: string;
  price: string;
};

export enum FormPrintColorEnum {
  BW = "black-and-white",
  COLOR = "color",
}

export enum FormPaperColorEnum {
  WHITE = "white",
  YELLOW = "yellow",
}
